import moment from "moment";

/** Moment format string aligned with existing dashboard screens (Orders, Inventory, etc.). */
export const DEFAULT_DISPLAY_DATE_FORMAT = "MMMM Do YYYY hh:mm:ss A";

/** Compact format for list/table rows so dates stay fully visible without truncation. */
export const LIST_DISPLAY_DATE_FORMAT = "MMM Do YYYY, hh:mm A";

const DISPLAY_EMPTY = "-";
/**
 * Formats a date for UI display. Always returns a string (never undefined).
 * If the input is a number, it is treated as a Unix timestamp in seconds.
 * If the input is a string, it is treated as an ISO string.
 * If the input is a Date, it is treated as a Date object.
 * If the input is falsy, it returns the empty string.
 * @param input ISO string, epoch (ms or heuristic seconds), Date, or falsy
 * @param formatString optional moment format; defaults to {@link DEFAULT_DISPLAY_DATE_FORMAT}
 */
export function formatDisplayDate(input, formatString = DEFAULT_DISPLAY_DATE_FORMAT) {
	if (input == null || input === "") {
		return DISPLAY_EMPTY;
	}

	const pattern = formatString ?? DEFAULT_DISPLAY_DATE_FORMAT;

	if (typeof input === "number") {
		if (!Number.isFinite(input) || input === 0) {
			return DISPLAY_EMPTY;
		}
		const m = moment(input);
		return m.isValid() ? m.format(pattern) : DISPLAY_EMPTY;
	}

	if (typeof input === "string") {
		const trimmed = input.trim();
		if (!trimmed) {
			return DISPLAY_EMPTY;
		}
		const m = moment(trimmed);
		return m.isValid() ? m.format(pattern) : DISPLAY_EMPTY;
	}

	if (input instanceof Date) {
		const m = moment(input);
		return m.isValid() ? m.format(pattern) : DISPLAY_EMPTY;
	}

	return DISPLAY_EMPTY;
}
